module.exports = __webpack_public_path__ + "dimer/static/img/18.7acad3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/18.jpg
// module id = 6/o2
// module chunks = 0